import React from 'react';
import { serverSideTranslation } from '../util/next';
import Page from '../components/Layout/Page';
import VideoTopBanner from '../modules/VideoTopBanner';
import TechnologyConetnt from '../modules/TechnologyConetnt';
import { getPageContent } from '../api/pagesApi';

import { genShareConfig } from '../components/Share/use-config-share';

interface Props {
  pageContentData: any;
  _nextI18Next: any;
}

const Technology = (props: Props) => {
  const { pageContentData, _nextI18Next: i18n } = props;
  const { pageContent = {}, shareContent = {} } = pageContentData || {};
  // 优先读取 page 字段（新版配置），兼容旧版配置
  const content = pageContent.page || pageContent;
  const { videoTitle, videoUrl, videoPoster, poster, videoPlayText } = content;
  const {
    manMachineData,
    productIntroDataArr,
    aiApplicationData,
    toolData,
    productCardDataArr,
    newsTextData,
    researchCooperationData,
    scientificCooperationData,
  } = content;
  const { newsTitleText, newsMoreText } = newsTextData;

  return (
    <Page title={shareContent.shareTitle}>
      <div className="bg-white">
        {/* 顶部视频模块 */}
        <VideoTopBanner
          videoPlayText={videoPlayText}
          videoTitle={videoTitle}
          videoLink={videoUrl}
          videoCoverImg={videoPoster}
          poster={poster}
          loop={false}
        />
        {/* 我们的科技内容模块（含新闻模块） */}
        <TechnologyConetnt
          manMachineData={manMachineData}
          productIntroDataArr={productIntroDataArr}
          aiApplicationData={aiApplicationData}
          toolData={toolData}
          productCardDataArr={productCardDataArr}
          researchCooperationData={researchCooperationData}
          scientificCooperationData={scientificCooperationData}
          newsGroupData={{
            lanType: i18n.initialLocale,
            newsTitleText,
            newsMoreText,
          }}
        />
      </div>
    </Page>
  );
};

// 设置页面风格
// Technology.theme = 'dark';
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/technology',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_z52ltock',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['technology', 'cookie', 'common'])),
    },
  };
}

export default Technology;
